module.exports = __webpack_public_path__ + "img/justin.c000ab6a.jpeg";